import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, HostBinding, ViewChild, Optional, NgModule } from '@angular/core';
import * as i2 from 'se-fe-button';
import { SeFeButtonModule } from 'se-fe-button';
import * as i4 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import { __awaiter } from 'tslib';
import * as i2$1 from '@angular/forms';
import * as i3 from 'se-fe-form-field-options';
import { SeFeFormFieldOptionsModule } from 'se-fe-form-field-options';
import { SeFeScrollModule } from 'se-fe-scroll';

class SeFeModalSpinnerService {
    activate(button) {
        this.activeButton = button;
    }
    stop() {
        this.activeButton = undefined;
    }
    isActive(button) {
        return this.activeButton && this.activeButton === button;
    }
}
SeFeModalSpinnerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalSpinnerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SeFeModalSpinnerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalSpinnerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalSpinnerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class SeFeModalButtonComponent {
    constructor(spinner, el) {
        this.spinner = spinner;
        this.el = el;
        this.emphasis = 'low';
        this.loadingLabel = 'loading';
        this.action = new EventEmitter();
    }
    ngOnInit() {
        var _a, _b, _c, _d, _e, _f;
        if ((_a = this.button) === null || _a === void 0 ? void 0 : _a.primary)
            this.emphasis = 'high';
        if ((_b = this.button) === null || _b === void 0 ? void 0 : _b.secondary)
            this.emphasis = 'medium';
        if (((_c = this.button) === null || _c === void 0 ? void 0 : _c.minimal) || ((_d = this.button) === null || _d === void 0 ? void 0 : _d.cancel))
            this.emphasis = 'low';
        if ((_e = this.button) === null || _e === void 0 ? void 0 : _e.loadingLabel)
            this.loadingLabel = (_f = this.button) === null || _f === void 0 ? void 0 : _f.loadingLabel;
    }
    onClick() {
        const modalTrigger = this.el.nativeElement.querySelector('button');
        this.action.emit(modalTrigger);
    }
}
SeFeModalButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalButtonComponent, deps: [{ token: SeFeModalSpinnerService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SeFeModalButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeModalButtonComponent, selector: "se-fe-modal-button", inputs: { button: ["seFeDataButton", "button"], seFeDataIndicatorDot: "seFeDataIndicatorDot", seFeDataIndicatorDotColor: "seFeDataIndicatorDotColor" }, outputs: { action: "seFeButtonAction" }, ngImport: i0, template: "<se-fe-button\n  *ngIf=\"!this.button?.destructive && !this.button?.back\"\n  [seFeDataEmphasis]=\"this.emphasis\"\n  [seFeDataIsLoading]=\"spinner.isActive(button)\"\n  [seFeDataIndicatorDot]=\"seFeDataIndicatorDot\"\n  [seFeDataIndicatorDotColor]=\"seFeDataIndicatorDotColor\"\n  [seFeDataIsDisabled]=\"spinner.isActive(button)\"\n  [seFeDataLoadingLabel]=\"loadingLabel\"\n  [seFeDataFullWidth]=\"true\"\n  (click)=\"onClick()\">\n  <ng-content select=\"[seFeModalIcon]\"></ng-content>\n  <span *ngIf=\"button?.label\">\n    {{ button?.label }}\n  </span>\n</se-fe-button>\n\n<se-fe-back-button\n  *ngIf=\"this.button?.back\"\n  [seFeDataIsLoading]=\"spinner.isActive(button)\"\n  [seFeDataLoadingLabel]=\"loadingLabel\"\n  (click)=\"onClick()\">\n  <span *ngIf=\"button?.label\">\n    {{ button?.label }}\n  </span>\n</se-fe-back-button>\n\n<se-fe-destructive-button\n  *ngIf=\"this.button?.destructive\"\n  [seFeDataIsLoading]=\"spinner.isActive(button)\"\n  [seFeDataLoadingLabel]=\"loadingLabel\"\n  [seFeDataIsDisabled]=\"spinner.isActive(button)\"\n  [seFeDataFullWidth]=\"true\"\n  (click)=\"onClick()\">\n  <span *ngIf=\"button?.label\">\n    {{ button?.label }}\n  </span>\n</se-fe-destructive-button>\n", styles: [":host{margin:0;display:inline-flex;vertical-align:bottom;border-radius:4px}\n"], components: [{ type: i2.SeFeButtonComponent, selector: "se-fe-button, se-fe-destructive-button, se-fe-back-button, se-fe-upgrade-button, se-fe-icon-button", inputs: ["seFeDataIsDisabled", "seFeDataFocusableOnDisabled", "seFeDataEmphasis", "seFeDataIsLoading", "seFeDataFullWidth", "seFeDataType", "seFeDataLoadingLabel", "seFeDataIndicatorDot", "seFeDataIndicatorDotColor", "seFeDataButtonAttrs", "seFeDataSnug", "seFeDataSmall"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-modal-button',
                    templateUrl: './se-fe-modal-button.component.html',
                    styleUrls: ['./se-fe-modal-button.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: SeFeModalSpinnerService }, { type: i0.ElementRef }]; }, propDecorators: { button: [{
                type: Input,
                args: ['seFeDataButton']
            }], seFeDataIndicatorDot: [{
                type: Input,
                args: ['seFeDataIndicatorDot']
            }], seFeDataIndicatorDotColor: [{
                type: Input,
                args: ['seFeDataIndicatorDotColor']
            }], action: [{
                type: Output,
                args: ['seFeButtonAction']
            }] } });

function isConfirm(ref) {
    var _a;
    return !!((_a = ref.nativeElement.parentElement) === null || _a === void 0 ? void 0 : _a.closest('se-fe-confirm'));
}

class SeFeModalContentComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.stickyBottom = false;
        this.stickyTop = false;
        this.baseClass = true;
        this.isStuck = false;
        // noop
    }
    get el() {
        return this.elementRef.nativeElement;
    }
    ngOnChanges() {
        if (this.stickyBottom || this.stickyTop)
            this.observeSticky();
        else
            this.stopObservicengSticky();
    }
    ngOnDestroy() {
        this.stopObservicengSticky();
    }
    observeSticky() {
        if (this.stickyObserver)
            return;
        const threshold = .99;
        const updateClass = ([e]) => {
            e.target.classList.toggle('se-fe-modal-content--sticky', e.intersectionRatio < threshold);
        };
        this.stickyObserver = new IntersectionObserver(updateClass, { threshold });
        this.stickyObserver.observe(this.el);
    }
    stopObservicengSticky() {
        if (!this.stickyObserver)
            return;
        this.stickyObserver.unobserve(this.el);
    }
}
SeFeModalContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalContentComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SeFeModalContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeModalContentComponent, selector: "se-fe-modal-content", inputs: { stickyBottom: ["seFeDataStickyBottom", "stickyBottom"], stickyTop: ["seFeDataStickyTop", "stickyTop"] }, host: { properties: { "class.se-fe-modal-content--sticky-bottom": "this.stickyBottom", "class.se-fe-modal-content--sticky-top": "this.stickyTop", "class.se-fe-modal-content": "this.baseClass" } }, usesOnChanges: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host.se-fe-modal-content--sticky-bottom,:host.se-fe-modal-content--sticky-top{position:sticky;background:var(--se-bg);z-index:var(--se-z-sticky)}:host{display:block;padding:var(--se-container-spacing)}:host:empty{display:none}:host.se-fe-modal-content--sticky-top{top:-1px}:host.se-fe-modal-content--sticky-top.se-fe-modal-content--sticky{border-bottom:1px solid var(--se-border);box-shadow:0 4px 5px var(--se-shadow);margin-bottom:-2px;padding-top:calc(var(--se-container-spacing) + 1px)}:host.se-fe-modal-content--sticky-bottom{bottom:-1px}:host.se-fe-modal-content--sticky-bottom.se-fe-modal-content--sticky{box-shadow:0 -4px 5px var(--se-shadow);margin-top:-1px;padding-bottom:calc(var(--se-container-spacing) + 1px)}:host-context(.se-fe-modal-content)+:host{border-top:1px solid var(--se-border)}@media (max-width: 599px),(max-height: 599px){:host-context(se-fe-modal)~.se-fe-modal:not(.se-fe-modal--confirm)>*>*>*>:host{padding:var(--se-container-spacing-mobile)}}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-modal-content',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-modal-content.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { stickyBottom: [{
                type: Input,
                args: ['seFeDataStickyBottom']
            }, {
                type: HostBinding,
                args: ['class.se-fe-modal-content--sticky-bottom']
            }], stickyTop: [{
                type: Input,
                args: ['seFeDataStickyTop']
            }, {
                type: HostBinding,
                args: ['class.se-fe-modal-content--sticky-top']
            }], baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-modal-content']
            }] } });

let MODAL_COUNTER = 1;
const TIME_STAMP$1 = Date.now();
const ANIMATION_DURATION = 150;
const ANIMATION_DURATION_MOBILE = 300;
const MAX_WIDTH_MOBILE = 599;
const SWIPE_DIFF = 10;
class SeFeModalComponent {
    constructor(viewContainerRef, elementRef, detector, spinner) {
        this.viewContainerRef = viewContainerRef;
        this.elementRef = elementRef;
        this.detector = detector;
        this.spinner = spinner;
        this.id = `se-fe-modal-${TIME_STAMP$1}-${MODAL_COUNTER++}`;
        this.themeReset = true;
        this.size = 'medium';
        this.seFeBeforeOpen = new EventEmitter();
        this.seFeClose = new EventEmitter();
        this.seFeAfterClose = new EventEmitter();
        this.isOpen = false;
        this.opening = false;
        this.closing = false;
        this.titleId = undefined;
        this.gripStart = (e) => {
            if (this.isDesktop)
                return;
            this.touchY = e.touches[0].clientY;
            this.watchSwipe();
        };
        this.gripMove = (e) => {
            const touchY = e.touches[0].clientY;
            if (this.touchY - touchY > SWIPE_DIFF) {
                this.cancelSwipe(); // ignore swipe up
            }
            else if (touchY - this.touchY > SWIPE_DIFF) {
                this.gripEnd(); // close on swipe down
            }
        };
        this.gripEnd = () => {
            this.cancelSwipe();
            this.close();
        };
    }
    get confirmClass() { return isConfirm(this.elementRef); }
    get isDesktop() {
        return window.innerWidth > MAX_WIDTH_MOBILE && window.innerHeight > MAX_WIDTH_MOBILE;
    }
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.modalRef);
        this.detector.detectChanges();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.titleId = this.retrieveTitleID;
            this.detector.detectChanges();
        });
    }
    ngOnDestroy() {
        const el = this.modalRef.elementRef.nativeElement;
        if (!el)
            return;
        const parent = el.parentNode;
        if (parent)
            parent.removeChild(el);
        this.isOpen = false;
        this.detector.detach();
    }
    scrollToTop() {
        this.contentRef.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
        this.contentRef.nativeElement.scrollIntoView(); // this does it for mobile
    }
    open(trigger) {
        if (this.isOpen)
            return;
        if (trigger)
            this.triggerEl = this.findFocusableElement(trigger);
        this.spinner.stop();
        this.isOpen = true;
        this.appendToBody();
        this.animateOpening();
        setTimeout(() => this.modalContainer.nativeElement.focus());
    }
    close() {
        if (!this.isOpen)
            return;
        this.isOpen = false;
        this.animateClosing();
        this.seFeClose.emit();
        if (this.triggerEl)
            this.triggerEl.focus();
    }
    outsideClick(evt) {
        const clickedInside = evt.composedPath().includes(this.modalContainer.nativeElement);
        if (!clickedInside && this.isOpen) {
            evt.stopPropagation();
            this.close();
            evt.preventDefault();
        }
    }
    get retrieveTitleID() {
        if (this.headerRef.nativeElement.querySelector('.se-fe-modal__title')) {
            const titleEl = this.headerRef.nativeElement.querySelector('.se-fe-modal__title');
            return titleEl.getAttribute('id');
        }
        return null;
    }
    handleKeydown(event) {
        if (event.code === 'Escape') {
            event.stopPropagation();
            this.close();
        }
    }
    touchstart(e) {
        if (this.isDesktop)
            return;
        this.touchstartY = e.touches[0].clientY;
    }
    touchmove(e) {
        if (this.isDesktop)
            return;
        e.stopPropagation();
        const touchY = e.touches[0].clientY;
        const content = e.target.closest('.se-fe-modal__content');
        let prevent = !content;
        if (content) {
            const scrolling = content.clientHeight !== content.scrollHeight;
            const atBottom = content.clientHeight + content.scrollTop === content.scrollHeight;
            const atTop = content.scrollTop === 0;
            const swipeDown = touchY - this.touchstartY > 0;
            const swipeUp = touchY - this.touchstartY < 0;
            prevent = !scrolling || atBottom && swipeUp || atTop && swipeDown;
        }
        if (prevent)
            e.preventDefault();
    }
    watchSwipe() {
        this.gripRef.nativeElement.addEventListener('touchmove', this.gripMove);
        this.gripRef.nativeElement.addEventListener('touchend', this.gripEnd);
    }
    cancelSwipe() {
        this.gripRef.nativeElement.removeEventListener('touchmove', this.gripMove);
        this.gripRef.nativeElement.removeEventListener('touchend', this.gripEnd);
    }
    appendToBody() {
        document.body.appendChild(this.modalRef.elementRef.nativeElement);
    }
    animateOpening() {
        this.opening = true;
        this.seFeBeforeOpen.emit();
        this.timeout = window.setTimeout(() => {
            this.opening = false;
            this.detector.detectChanges();
        }, this.animationDuration);
    }
    animateClosing() {
        this.closing = true;
        this.timeout = window.setTimeout(() => {
            this.closing = false;
            this.detector.detectChanges();
            this.seFeAfterClose.emit();
        }, this.animationDuration);
    }
    get animationDuration() {
        const mobile = this.confirmClass && window.innerWidth <= MAX_WIDTH_MOBILE;
        return mobile ? ANIMATION_DURATION_MOBILE : ANIMATION_DURATION;
    }
    findFocusableElement(element) {
        if (!(element instanceof HTMLElement))
            return null;
        const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        while (element) {
            if (element === null || element === void 0 ? void 0 : element.matches(focusableElements)) {
                return element;
            }
            element = element.parentElement;
        }
        return null;
    }
    get classAttr() {
        const classes = ['se-fe-modal', `se-fe-modal--${this.size}`];
        if (this.isOpen || this.opening || this.closing)
            classes.push('se-fe-modal--open');
        if (this.opening)
            classes.push('se-fe-modal--opening');
        if (this.closing)
            classes.push('se-fe-modal--closing');
        if (!this.isOpen)
            classes.push('se-fe-modal--closed');
        return classes.join(' ');
    }
}
SeFeModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalComponent, deps: [{ token: i0.ViewContainerRef }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: SeFeModalSpinnerService }], target: i0.ɵɵFactoryTarget.Component });
SeFeModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeModalComponent, selector: "se-fe-modal", inputs: { size: ["seFeDataSize", "size"] }, outputs: { seFeBeforeOpen: "seFeBeforeOpen", seFeClose: "seFeClose", seFeAfterClose: "seFeAfterClose" }, host: { properties: { "id": "this.id", "class.se-fe-theme--reset": "this.themeReset", "class.se-fe-modal--confirm": "this.confirmClass" } }, viewQueries: [{ propertyName: "modalRef", first: true, predicate: ["modalRef"], descendants: true, static: true }, { propertyName: "contentRef", first: true, predicate: ["contentRef"], descendants: true }, { propertyName: "gripRef", first: true, predicate: ["gripRef"], descendants: true }, { propertyName: "headerRef", first: true, predicate: ["headerRef"], descendants: true }, { propertyName: "footerRef", first: true, predicate: ["footerRef"], descendants: true }, { propertyName: "modalContainer", first: true, predicate: ["modalContainer"], descendants: true }], ngImport: i0, template: "<ng-template #modalRef>\n  <div\n    [ngClass]=\"classAttr\"\n    (keydown)=\"handleKeydown($event)\"\n    (mousedown)=\"outsideClick($event)\"\n    (touchstart)=\"touchstart($event)\"\n    (touchmove)=\"touchmove($event)\">\n    <div class=\"se-fe-modal__overlay\"></div>\n    <div\n      #modalContainer\n      class=\"se-fe-modal__container\"\n      [cdkTrapFocus]=\"isOpen\"\n      aria-modal=\"true\"\n      [attr.aria-labelledby]=\"titleId\"\n      tabindex=\"-1\"\n      role=\"dialog\">\n      <div #gripRef class=\"se-fe-modal__grip\" (touchstart)=\"gripStart($event)\"></div>\n      <div class=\"se-fe-modal__content\" [attr.aria-labelledby]=\"titleId\">\n        <div #headerRef>\n          <ng-content select=\"[seFeModalHeader]\"></ng-content>\n        </div>\n        <div #contentRef class=\"se-fe-modal__content--inner\">\n          <ng-content select=\"se-fe-modal-content\"></ng-content>\n          <se-fe-modal-content><ng-content select=\"[seFeModalContent]\"></ng-content></se-fe-modal-content>\n        </div>\n      </div>\n      <div #footerRef>\n        <ng-content select=\"[seFeModalFooter]\"></ng-content>\n      </div>\n    </div>\n  </div>\n</ng-template>\n", styles: [":host{display:none}@keyframes seFeModalFade{0%{opacity:0}to{opacity:1}}@keyframes seFeModalPop{0%{opacity:0;transform:scale(.9)}to{opacity:1;transform:scale(1)}}@keyframes seModalSlideOpen{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes seModalSlideClosed{to{transform:translateY(100%)}}.se-fe-modal{--se-bg: var(--se-overlay-bg);align-items:center;bottom:0;color:var(--se-text);display:none;font:var(--se-body-font);justify-content:center;left:0;pointer-events:none;position:fixed;top:0;width:100%;z-index:var(--se-z-overlay)}.se-fe-modal--open{display:flex;pointer-events:all}.se-fe-modal--opening,.se-fe-modal--closing,.se-fe-modal--disabled{pointer-events:none}.se-fe-modal__grip{display:none}.se-fe-modal__overlay{backface-visibility:hidden;background:rgba(35,40,43,.7);bottom:0;left:0;position:absolute;right:0;top:0;z-index:-1}.se-fe-modal--opening .se-fe-modal__overlay{animation:.15s forwards seFeModalFade}.se-fe-modal--closing .se-fe-modal__overlay{animation:.15s reverse backwards seFeModalFade}.se-fe-modal__container{align-items:stretch;background:var(--se-bg);border-radius:2px;box-shadow:var(--se-overlay-shadow);display:none;flex-direction:column;max-height:calc(100% - var(--se-container-spacing) * 2);max-width:calc(100% - var(--se-container-spacing) * 2)}.se-fe-modal__container:focus{outline:none}.se-fe-modal--small .se-fe-modal__container{width:350px}.se-fe-modal--medium .se-fe-modal__container{width:500px}.se-fe-modal--large .se-fe-modal__container{width:750px}.se-fe-modal--open .se-fe-modal__container{display:flex}.se-fe-modal--opening .se-fe-modal__container,.se-fe-modal--closing .se-fe-modal__container{pointer-events:none}.se-fe-modal__container>*:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.se-fe-modal__container>*:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.se-fe-modal__content{border-top-left-radius:inherit;border-top-right-radius:inherit;display:flex;flex:1 1000 auto;flex-direction:column;height:100%;overflow:hidden}.se-fe-modal__content--inner{-webkit-overflow-scrolling:touch;flex:1 1000 auto;height:100%;overflow:visible;position:relative}@media (min-width: 600px) and (min-height: 600px){.se-fe-modal__content--inner{overflow-x:hidden;overflow-y:auto;overscroll-behavior:none}}@media (max-width: 599px),(max-height: 599px){:host:not(.se-fe-modal--confirm)~.se-fe-modal{align-items:flex-end}:host:not(.se-fe-modal--confirm)~.se-fe-modal .se-fe-modal__grip{display:block;height:150vh;left:0;position:absolute;transform:translateY(calc(var(--se-container-spacing-mobile) - 150vh));width:100%;z-index:var(--se-z-overlay)-1}:host:not(.se-fe-modal--confirm)~.se-fe-modal .se-fe-modal__grip:before{position:absolute;background:var(--se-subdued-icon);border-radius:2px;content:\"\";display:block;height:4px;bottom:var(--se-container-spacing-mobile)-4px-4px;left:calc(50% - 25px);width:50px}:host:not(.se-fe-modal--confirm)~.se-fe-modal .se-fe-modal__container{border-radius:0;max-height:calc(100% - 48px);max-width:100%;width:100%}:host:not(.se-fe-modal--confirm)~.se-fe-modal .se-fe-modal__content{-webkit-overflow-scrolling:touch;display:block;flex:1 1000 auto;overflow-x:hidden;overflow-y:auto;overscroll-behavior:none}:host:not(.se-fe-modal--confirm)~.se-fe-modal--opening .se-fe-modal__overlay{animation:.3s forwards seFeModalFade}:host:not(.se-fe-modal--confirm)~.se-fe-modal--opening .se-fe-modal__container{animation:.3s ease forwards seModalSlideOpen}:host:not(.se-fe-modal--confirm)~.se-fe-modal--closing .se-fe-modal__overlay{animation:.3s reverse backwards seFeModalFade}:host:not(.se-fe-modal--confirm)~.se-fe-modal--closing .se-fe-modal__container{animation:.3s ease forwards seModalSlideClosed}}@media (min-width: 600px),(max-height: 599px){:host:not(.se-fe-modal--confirm)~.se-fe-modal .se-fe-modal__container{max-height:100%}}\n"], components: [{ type: SeFeModalContentComponent, selector: "se-fe-modal-content", inputs: ["seFeDataStickyBottom", "seFeDataStickyTop"] }], directives: [{ type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-modal',
                    templateUrl: './se-fe-modal.component.html',
                    styleUrls: ['./se-fe-modal.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: SeFeModalSpinnerService }]; }, propDecorators: { id: [{
                type: HostBinding,
                args: ['id']
            }], themeReset: [{
                type: HostBinding,
                args: ['class.se-fe-theme--reset']
            }], confirmClass: [{
                type: HostBinding,
                args: ['class.se-fe-modal--confirm']
            }], modalRef: [{
                type: ViewChild,
                args: ['modalRef', { static: true }]
            }], contentRef: [{
                type: ViewChild,
                args: ['contentRef', { static: false }]
            }], gripRef: [{
                type: ViewChild,
                args: ['gripRef', { static: false }]
            }], headerRef: [{
                type: ViewChild,
                args: ['headerRef', { static: false }]
            }], footerRef: [{
                type: ViewChild,
                args: ['footerRef', { static: false }]
            }], modalContainer: [{
                type: ViewChild,
                args: ['modalContainer', { static: false }]
            }], size: [{
                type: Input,
                args: ['seFeDataSize']
            }], seFeBeforeOpen: [{
                type: Output
            }], seFeClose: [{
                type: Output
            }], seFeAfterClose: [{
                type: Output
            }] } });

class SeFeModalFooterComponent {
    constructor(changeDetectorRef, spinner, elementRef, fb) {
        this.changeDetectorRef = changeDetectorRef;
        this.spinner = spinner;
        this.elementRef = elementRef;
        this.fb = fb;
        this.action = new EventEmitter();
        this.spinnerDelay = 100;
        // noop
    }
    get confirmClass() { return isConfirm(this.elementRef); }
    ngOnChanges(changes) {
        if (changes.checkText || changes.checked) {
            if (!this.fb)
                throw new Error('You must include FormBuilder to use the SeFeCheckbox feature of the SeFeModal');
            this.form = this.fb.group({ checked: [!!this.checked] });
            this.checkedOptions = [{ label: this.checkText, value: true }];
        }
    }
    reset() {
        this.cancelSpinner();
    }
    cancelSpinner() {
        this.spinner.stop();
        window.clearTimeout(this.spinningTimer);
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    doAction(button) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.delaySpinner(button);
            this.action.emit(button.action((_b = (_a = this.form) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.checked));
        });
    }
    delaySpinner(button) {
        this.spinningTimer = window.setTimeout(() => {
            this.spinner.activate(button);
            this.changeDetectorRef.detectChanges();
        }, this.spinnerDelay);
    }
    // TODO: remove this complexity once buttons no loger have shadows
    get groupClassName() {
        const baseClass = 'se-fe-modal-button-group';
        const flat = this.buttons && !!this.buttons.find(btn => btn.secondary);
        return flat ? `${baseClass} ${baseClass}--flat` : baseClass;
    }
}
SeFeModalFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalFooterComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: SeFeModalSpinnerService }, { token: i0.ElementRef }, { token: i2$1.FormBuilder, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SeFeModalFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeModalFooterComponent, selector: "se-fe-modal-footer", inputs: { buttons: ["seFeDataFooterButtons", "buttons"], checked: ["seFeCheckboxChecked", "checked"], checkText: ["seFeCheckboxText", "checkText"] }, outputs: { action: "seFeButtonAction" }, host: { properties: { "class.se-fe-modal--confirm": "this.confirmClass" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"se-fe-modal-footer\" [ngClass]=\"groupClassName\">\n  <ng-container *ngIf=\"form\" [formGroup]=\"form\">\n    <se-fe-checkbox\n      class=\"se-fe-modal-footer__checkbox\"\n      formControlName=\"checked\"\n      [seFeDataOptions]=\"checkedOptions\">\n    </se-fe-checkbox>\n  </ng-container>\n  <div class=\"se-fe-moda-footer__buttons\">\n    <se-fe-modal-button\n      *ngFor=\"let button of buttons\"\n      (seFeButtonAction)=\"doAction(button)\"\n      [seFeDataButton]=\"button\">\n    </se-fe-modal-button>\n  </div>\n</div>\n", styles: [".se-fe-modal-footer{align-items:center;border-top:1px solid var(--se-border);display:flex;flex-direction:column;grid-gap:var(--se-content-spacing);gap:var(--se-content-spacing);flex-wrap:nowrap;justify-content:flex-end;align-items:flex-end;padding:var(--se-container-spacing)}.se-fe-moda-footer__buttons{display:flex;grid-gap:var(--se-content-spacing);gap:var(--se-content-spacing);justify-content:flex-end;width:100%;flex-wrap:wrap}.se-fe-moda-footer__buttons se-fe-modal-button:has(se-fe-back-button){flex:3}.se-fe-modal-footer__checkbox{align-self:flex-start}@media (min-width: 600px){:host:not(.se-fe-modal--confirm) .se-fe-modal-footer__checkbox{margin:-6px 0}}@media (max-width: 599px),(max-height: 599px){:host:not(.se-fe-modal--confirm) .se-fe-modal-footer{padding:var(--se-container-spacing-mobile)}:host:not(.se-fe-modal--confirm) .se-fe-moda-footer__buttons:has(se-fe-modal-button:nth-child(2):nth-last-child(1)) se-fe-modal-button:not(:has(se-fe-back-button)){flex:100%}:host:not(.se-fe-modal--confirm) .se-fe-moda-footer__buttons se-fe-modal-button:last-of-type{flex-basis:100%}}@media (max-width: 599px){:host:not(.se-fe-modal--confirm) .se-fe-modal-button-group{display:flex;flex-wrap:wrap;flex-direction:column-reverse}:host:not(.se-fe-modal--confirm) .se-fe-modal-button-group>*{width:100%;flex:0 0 auto}:host:not(.se-fe-modal--confirm) .se-fe-modal-footer__checkbox{margin-top:0-var(--se-content-spacing-small);order:2}}\n"], components: [{ type: i3.SeFeFormFieldOptionsCheckboxComponent, selector: "se-fe-checkbox", inputs: ["seFeDataOptions", "seFeDataIndeterminate", "seFeDataHiddenLabel"] }, { type: SeFeModalButtonComponent, selector: "se-fe-modal-button", inputs: ["seFeDataButton", "seFeDataIndicatorDot", "seFeDataIndicatorDotColor"], outputs: ["seFeButtonAction"] }], directives: [{ type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-modal-footer',
                    templateUrl: './se-fe-modal-footer.component.html',
                    styleUrls: ['./se-fe-modal-footer.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: SeFeModalSpinnerService }, { type: i0.ElementRef }, { type: i2$1.FormBuilder, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { confirmClass: [{
                type: HostBinding,
                args: ['class.se-fe-modal--confirm']
            }], buttons: [{
                type: Input,
                args: ['seFeDataFooterButtons']
            }], checked: [{
                type: Input,
                args: ['seFeCheckboxChecked']
            }], checkText: [{
                type: Input,
                args: ['seFeCheckboxText']
            }], action: [{
                type: Output,
                args: ['seFeButtonAction']
            }] } });

let MODAL_DESC_COUNTER = 1;
const TIME_STAMP = Date.now();
class SeFeModalHeaderComponent {
    constructor(modal, elementRef) {
        this.modal = modal;
        this.elementRef = elementRef;
        this.close = new EventEmitter();
        this.modalTitleId = `se-fe-modal-title-${TIME_STAMP}-${MODAL_DESC_COUNTER++}`;
        this.closeButton = {
            icon: true,
        };
        // noop
    }
    get confirmClass() { return isConfirm(this.elementRef); }
}
SeFeModalHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalHeaderComponent, deps: [{ token: SeFeModalComponent }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SeFeModalHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeModalHeaderComponent, selector: "se-fe-modal-header", inputs: { title: ["seFeDataTitle", "title"] }, outputs: { close: "seFeButtonAction" }, host: { properties: { "class.se-fe-modal--confirm": "this.confirmClass" } }, viewQueries: [{ propertyName: "closeModalButton", first: true, predicate: ["closeButton"], descendants: true }], ngImport: i0, template: "<div class=\"se-fe-modal-header\">\n  <div class=\"se-fe-modal__title\" [attr.id]=\"modalTitleId\">{{ title }}</div>\n  <div class=\"se-fe-modal__close\">\n    <se-fe-modal-button\n      (seFeButtonAction)=\"modal.close()\"\n      [seFeDataButton]=\"closeButton\">\n      <svg class=\"se-fe-modal__close-icon\" seFeModalIcon width=\"24\" height=\"24\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\">\n        <g>\n          <path d=\"m12 13.4-4.9 4.9a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.275-.7c0-.283.091-.517.275-.7l4.9-4.9-4.9-4.9a.948.948 0 0 1-.275-.7c0-.283.091-.517.275-.7a.948.948 0 0 1 .7-.275c.283 0 .516.092.7.275l4.9 4.9 4.9-4.9a.948.948 0 0 1 .7-.275c.283 0 .516.092.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7L13.4 12l4.9 4.9a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275L12 13.4z\"/>\n        </g>\n      </svg>\n    </se-fe-modal-button>\n  </div>\n</div>\n", styles: [".se-fe-modal-header{align-items:center;background:var(--se-bg);border-bottom:1px solid var(--se-border);display:flex;flex:0 0 auto;flex-wrap:nowrap;justify-content:space-between;padding:var(--se-container-spacing)}.se-fe-modal__title{font:var(--se-section-title-font)}.se-fe-modal__close-icon{display:block;fill:var(--se-icon)}@media (max-width: 599px),(max-height: 599px){:host:not(.se-fe-modal--confirm) .se-fe-modal-header{padding:var(--se-container-spacing-mobile)}:host:not(.se-fe-modal--confirm) .se-fe-modal__title{font:var(--se-small-title-font)}:host:not(.se-fe-modal--confirm) .se-fe-modal__close{display:none}}\n"], components: [{ type: SeFeModalButtonComponent, selector: "se-fe-modal-button", inputs: ["seFeDataButton", "seFeDataIndicatorDot", "seFeDataIndicatorDotColor"], outputs: ["seFeButtonAction"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-modal-header',
                    templateUrl: './se-fe-modal-header.component.html',
                    styleUrls: ['./se-fe-modal-header.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: SeFeModalComponent }, { type: i0.ElementRef }]; }, propDecorators: { confirmClass: [{
                type: HostBinding,
                args: ['class.se-fe-modal--confirm']
            }], title: [{
                type: Input,
                args: ['seFeDataTitle']
            }], close: [{
                type: Output,
                args: ['seFeButtonAction']
            }], closeModalButton: [{
                type: ViewChild,
                args: ['closeButton', { static: false }]
            }] } });

class SeFeModalModule {
}
SeFeModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalModule, declarations: [SeFeModalButtonComponent,
        SeFeModalComponent,
        SeFeModalContentComponent,
        SeFeModalFooterComponent,
        SeFeModalHeaderComponent], imports: [CommonModule,
        SeFeButtonModule,
        SeFeFormFieldOptionsModule,
        SeFeScrollModule,
        A11yModule], exports: [SeFeModalButtonComponent,
        SeFeModalComponent,
        SeFeModalContentComponent,
        SeFeModalFooterComponent,
        SeFeModalHeaderComponent,
        A11yModule] });
SeFeModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalModule, providers: [
        SeFeModalSpinnerService,
    ], imports: [[
            CommonModule,
            SeFeButtonModule,
            SeFeFormFieldOptionsModule,
            SeFeScrollModule,
            A11yModule,
        ], A11yModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SeFeModalButtonComponent,
                        SeFeModalComponent,
                        SeFeModalContentComponent,
                        SeFeModalFooterComponent,
                        SeFeModalHeaderComponent,
                    ],
                    imports: [
                        CommonModule,
                        SeFeButtonModule,
                        SeFeFormFieldOptionsModule,
                        SeFeScrollModule,
                        A11yModule,
                    ],
                    exports: [
                        SeFeModalButtonComponent,
                        SeFeModalComponent,
                        SeFeModalContentComponent,
                        SeFeModalFooterComponent,
                        SeFeModalHeaderComponent,
                        A11yModule,
                    ],
                    providers: [
                        SeFeModalSpinnerService,
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeModalButtonComponent, SeFeModalComponent, SeFeModalContentComponent, SeFeModalFooterComponent, SeFeModalHeaderComponent, SeFeModalModule };
